/**
 * RFC-091: Partner Dashboard
 * Main dashboard showing partner statistics and client overview
 */

import { createFileRoute } from '@tanstack/react-router';

import PartnerDashboard from '@/pages/partner/PartnerDashboard';



export const Route = createFileRoute('/(protected)/partner/')({
  component: PartnerDashboard,
});

